<template>
  <v-container>
    <div class="head-title mb-4">
      <h1 class="display-1">Sous-domaine d'activités</h1>
    </div>
    <HeaderTable>
      <v-data-table :headers="headers" :items="items" :search="search" no-results-text="Votre recherche n'a retourné aucun resultat" footer-props.items-per-page-text="Éléments par page" no-data-text="Aucune donnée disponible.">
        <template slot="items" slot-scope="props">
          <td>{{ props.item.id }}</td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </HeaderTable>
    <div class="floating-btn abs d-flex justify-content-end">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" @click="modal = true" color="primary" right top dark fab>
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <span>Ajouter</span>
      </v-tooltip>
    </div>
    <v-dialog v-model="modal" max-width="500px">
      <v-card>
        <v-card-text>
          <v-text-field label="Titre" type="text" requiered></v-text-field>
          <v-text-field label="Taux" type="number" requiered></v-text-field>
        </v-card-text>
        <v-card-actions class="justify-center pb-3">
          <v-btn color="primary"> <v-icon>save</v-icon> sauvegarder</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import HeaderTable from '@/components/helpers/HeaderTable.vue'
  export default {
    name: 'SousDomaineActivites',
    data: () => ({
      modal: false,
      search: '',
      items: [],
      headers: []
    }),
    components: {
      HeaderTable
    }
  }
</script>

<style scoped>

</style>